import * as React from 'react';
import { Dispatch } from 'redux';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './svs.module.css';
import { CounterExpertiseDTO as CounterExpertiseType } from '../../../../business/models/dto/svs/svs.dto';
import { tabCounterExpertiseFieldChange } from '../../../../store/details/svs/actions';
import { Role } from '../../../../store/shared/model';
import { BelfiusCurrencyInput } from 'src/components/custom/belfius-currency-input';

interface PropsFromState {
  data: CounterExpertiseType;
  readonly locked: boolean;
}

interface PropsFromDispatch {
  readonly tabCounterExpertiseFieldChange: typeof tabCounterExpertiseFieldChange;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class CounterExpertise extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.nameTP')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.counterExpertise.nameTP.placeholder')}
                value={this.props.data.nameTP}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCounterExpertiseFieldChange({ ...this.props.data, nameTP: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.nameTPCompany')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.counterExpertise.nameTPCompany.placeholder')}
                value={this.props.data.nameTPCompany}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCounterExpertiseFieldChange({ ...this.props.data, nameTPCompany: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.referte')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.counterExpertise.referte.placeholder')}
                value={this.props.data.referteTP}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCounterExpertiseFieldChange({ ...this.props.data, referteTP: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.realValue')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput
                className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.counterExpertise.realValue.placeholder')}
                value={this.props.data.realValue === '' || this.props.data.realValue === null ? '' : this.props.data.realValue.toString()}
                onValueChange={(values: { value: string }) => {
                  this.props.tabCounterExpertiseFieldChange({ ...this.props.data, realValue: values.value === '' ? '' : +values.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.nameExpert')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <input className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.counterExpertise.nameExpert.placeholder')}
                value={this.props.data.counterExpertSignedName}
                autoComplete='off'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.props.tabCounterExpertiseFieldChange({ ...this.props.data, counterExpertSignedName: event.target.value });
                }} />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.counterExpertise.info')}
              </span>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <textarea className={styles.input}
                    rows={2}
                    maxLength={120}
                    disabled={this.props.locked}
                    placeholder={this.localization.get('details.svs.remark.placeholder')}
                    value={this.props.data.comment}
                    autoComplete='off'
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                      this.props.tabCounterExpertiseFieldChange({ ...this.props.data, comment: event.target.value });
                    }} />
                </div>
            </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({ details: { detailsSvs }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  data: {
    nameTP: detailsSvs.counterExpertise.nameTP,
    nameTPCompany: detailsSvs.counterExpertise.nameTPCompany,
    realValue: detailsSvs.counterExpertise.realValue,
    referteTP: detailsSvs.counterExpertise.referteTP,
    counterExpertSignedName: detailsSvs.counterExpertise.counterExpertSignedName,
    comment: detailsSvs.counterExpertise.comment
  },
  locked: detailsSvs.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  tabCounterExpertiseFieldChange: (data: CounterExpertiseType) => dispatch(tabCounterExpertiseFieldChange(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(CounterExpertise);
